import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css'

const ServicesDropdownHeader2 = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <li className="dropdown">
      <div className="services-nav-container">
        <Link className="text-dark" to={"/services"}>
        <a className='nav-link ' id='services_submenu'>
        Services
        </a>
        </Link>
        <button
          onClick={toggleDropdown}
          className="dropdown-toggle-icon-header2"
          aria-expanded={isOpen}
        >
          <box-icon
            name={isOpen ? 'chevron-up' : 'chevron-down'}
            color="black"
          ></box-icon>
        </button>
      </div>

      <ul style={{zIndex:'1',marginTop:'50px'}} className={`dropdown-menu drpmenu ${isOpen ? 'show' : ''}`}>
        <li>
          <Link to="/web-development">
            Web Development
          </Link>
        </li>
        <li>
          <Link to="/graphic-designing">
            Graphic Designing
          </Link>
        </li>
        <li>
          <Link to="/search-engine-optimization">
            Search Engine Optimization
          </Link>
        </li>
        <li>
          <Link to="/network-security">
            Network and Security
          </Link>
        </li>
      </ul>
    </li>
  );
};

export default ServicesDropdownHeader2;
